import { T } from '@tolgee/react';
import { WrapperWidget } from '@agentselly/ui';
import { Button } from '~/components/ui/Button';

interface Props {
  readonly offerWebsiteURL: string;
  readonly benefitsWebsiteURL: string;
}

export function OfferWidget(props: Props) {
  return (
    <WrapperWidget>
      <div className="h-full flex flex-col gap-y-4">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
          <T>widget_offer_title</T>
        </h2>

        <p className="text-sm text-gray-600 dark:text-gray-400">
          <T>widget_offer_description</T>
        </p>

        <div className="self-start flex flex-wrap gap-3">
          <a
            href={props.offerWebsiteURL}
            target="_blank"
            rel="noreferrer"
            data-track="immodossier valiant offer contact link"
          >
            <Button showArrow>
              <T>widget_offer_button_offer</T>
            </Button>
          </a>
          <a
            className="hidden md:block"
            href={props.benefitsWebsiteURL}
            target="_blank"
            rel="noreferrer"
            data-track="immodossier valiant offer benefits link"
          >
            <Button showArrow>
              <T>widget_offer_button_benefits</T>
            </Button>
          </a>
        </div>
      </div>
    </WrapperWidget>
  );
}
